'use strict';

/**
 * Init Tour Logic
 */
class TWER_TOUR {

  /**
   * Сonstructor
   *
   * @param data
   */
  constructor(data) {

    TWER.tour = data.allowTour;
    TWER.tourAutoRun = data.allowTour;

    if (data.allowTour) {
      localStorage.setItem('toggleTourTag', 1);
      localStorage.setItem('toggleTourEnd', 1);
      localStorage.setItem('toggleTourNeverRunning', 1);

      let mainTourData = {
        'tourData': data.tourData,
        'tourPopUp': data.tourPopUp,
        'tourType': data.tourType,
        'tourFlySpeed': data.tourFlySpeed,
        'tourFlyCurve': data.tourFlyCurve,
        'tourLabelMarker': data.tourLabelMarker,
      };

      this.tourHandler(mainTourData);


      if (data.tourAutoRun) {
        TWER.map.once('idle', () => {
          setTimeout(() => {
            document.getElementById('btn-tour-right').click();
          }, 200);
        });
      }

    } else {
      localStorage.setItem('toggleTourTag', 0);
      localStorage.setItem('toggleTourEnd', 1);
      localStorage.setItem('toggleTourNeverRunning', 1);
    }

  }
  tourHandler (mainTourData) {

    let arr = JSON.parse(mainTourData.tourData);
    let tourPopUpGlobal = mainTourData.tourPopUp;
    let i = -1;
    let tourNumberContainer = document.getElementsByClassName('twer-tour-number-container-js');
    let tourNumber = document.getElementsByClassName('twer-tour-number');
    let tourNumberLabel = document.getElementsByClassName('twer-tour-number-label');
    const tourTextLabel = document.getElementsByClassName('text-label');
    let countedTour = arr.length;

    if (countedTour === 0) {
      return;
    }


    function twerStrInt(numInt) {
      return numInt.toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false
      });
    }

    function nextItem() {
      i = i + 1;
      i = i % arr.length;
      return {
        ix: i,
        data: arr[i]
      }
    }

    function prevItem() {
      if (i <= 0) { // i would become 0
        i = arr.length; // so put it at the other end of the array
      }
      i = i - 1; // decrease by one
      return {
        ix: i,
        data: arr[i]
      }
    }

    document.getElementById('btn-tour-left').addEventListener('click', (e) => {
      let prev = prevItem();
      if(typeof prev.data === 'undefined') return;

      TWER.tourInProgress = true;
      let prevData = prev.data;
      let idx = prev.ix + 1;
      let tourPopUpMarker = prevData.showPopUp;
      let advancedSettingsMarker = prevData.advanced_settings;

      console.log(tourTextLabel.length);
      if(!mainTourData.tourLabelMarker && tourTextLabel.length > 0){
        tourTextLabel[0].style.display = 'none';
      }

      if (typeof tourNumberContainer[0] !== 'undefined') {
        tourNumberContainer[0].classList.add('with-number');
        tourNumber[0].innerHTML = twerStrInt(idx) + '/' + twerStrInt(countedTour);

        if (mainTourData.tourLabelMarker) {
          tourNumberLabel[0].innerHTML = prevData.title;
        }
      }

      if (mainTourData.tourType === 'jump') {
        TWER.map.jumpTo({
          center: [prevData.geo.lang, prevData.geo.lat],
          zoom: prevData.zoom,
          pitch: prevData.pitch,
          bearing: prevData.bearing,
          padding: {
            top: prevData.tourOffsets.top,
            bottom: prevData.tourOffsets.bottom,
            left: prevData.tourOffsets.left,
            right: prevData.tourOffsets.right
          },
        });

      } else if (mainTourData.tourType === 'fly') {
        TWER.map.flyTo({
          center: [prevData.geo.lang, prevData.geo.lat],
          zoom: prevData.zoom,
          speed: parseFloat(prevData.flySpeed),
          curve: parseFloat(prevData.flyCurve),
          pitch: prevData.pitch,
          bearing: prevData.bearing,
          padding: {
            top: prevData.tourOffsets.top,
            bottom: prevData.tourOffsets.bottom,
            left: prevData.tourOffsets.left,
            right: prevData.tourOffsets.right
          },
        });
      }


      // If enable tourPopUpGlobal popups
      if(tourPopUpGlobal) {


        if(!advancedSettingsMarker || tourPopUpMarker) {
          // Close all popups except current popup
          TWER.closePopups([], {
            except: [prevData.id]
          });
        } else {
          // Close all popups
          TWER.closePopups();
        }


        if( !advancedSettingsMarker || (advancedSettingsMarker && tourPopUpMarker)) {
          // Open current popup with disable toggle
          let event = {};
          let coords = JSON.parse(prevData.geo.str);
          event.target = document.getElementById(`twer-popup-id-${prevData.id}`);



          TWER.openPopup(event, coords, {
            toggle: false
          });
        }
      } else {

        if(advancedSettingsMarker && tourPopUpMarker) {
          // Close all popups except current popup
          TWER.closePopups([], {
            except: [prevData.id]
          });

          // Open current popup with disable toggle
          let event = {};
          let coords = JSON.parse(prevData.geo.str);
          event.target = document.getElementById(`twer-popup-id-${prevData.id}`);

          TWER.openPopup(event, coords, {
            toggle: false
          });
        } else {
          // Close all popups if global tour popup disabled
          TWER.closePopups();
        }
      }


    });

    document.getElementById('btn-tour-right').addEventListener('click', (e) => {
      let next = nextItem();
      if(typeof next.data === 'undefined') return;
      TWER.tourInProgress = true;
      // the e here is the event itself
      let nextData = next.data;
      let idx = next.ix + 1;
      let tourPopUpMarker = nextData.showPopUp;
      let advancedSettingsMarker = nextData.advanced_settings;


      if(!mainTourData.tourLabelMarker && tourTextLabel.length > 0){
        tourTextLabel[0].style.display = 'none';
      }


      if (typeof tourNumberContainer[0] !== 'undefined') {
        tourNumberContainer[0].classList.add('with-number');
        tourNumber[0].innerHTML = twerStrInt(idx) + '/' + twerStrInt(countedTour);
        if (mainTourData.tourLabelMarker) {
          tourNumberLabel[0].innerHTML = nextData.title;
        }
      }

      if (mainTourData.tourType === 'jump') {
        TWER.map.jumpTo({
          center: [nextData.geo.lang, nextData.geo.lat],
          zoom: nextData.zoom,
          pitch: nextData.pitch,
          bearing: nextData.bearing,
          padding: {
            top: nextData.tourOffsets.top,
            bottom: nextData.tourOffsets.bottom,
            left: nextData.tourOffsets.left,
            right: nextData.tourOffsets.right
          },
        });

      } else if (mainTourData.tourType === 'fly') {
        TWER.map.flyTo({
          center: [
            nextData.geo.lang,
            nextData.geo.lat
          ],
          padding: {
            top: nextData.tourOffsets.top,
            bottom: nextData.tourOffsets.bottom,
            left: nextData.tourOffsets.left,
            right: nextData.tourOffsets.right
          },
          zoom: nextData.zoom,
          speed: parseFloat(nextData.flySpeed),
          curve: parseFloat(nextData.flyCurve),
          pitch: nextData.pitch,
          bearing: nextData.bearing
        });
      }

      // If enable tourPopUpGlobal popups
      if(tourPopUpGlobal) {

        if(!advancedSettingsMarker || tourPopUpMarker) {
          // Close all popups except current popup
          TWER.closePopups([], {
            except: [nextData.id]
          });
        } else {
          // Close all popups
          TWER.closePopups();
        }


        if( !advancedSettingsMarker || (advancedSettingsMarker && tourPopUpMarker)) {
          // Open current popup with disable toggle popups
          let event = {};
          let coords = JSON.parse(nextData.geo.str);
          event.target = document.getElementById(`twer-popup-id-${nextData.id}`);


          TWER.openPopup(event, coords, {
            toggle: false
          });
        }
      } else {
        if(advancedSettingsMarker && tourPopUpMarker) {
          // Close all popups except current popup
          TWER.closePopups([], {
            except: [nextData.id]
          });


          // Open current popup with disable toggle popups
          let event = {};
          let coords = JSON.parse(nextData.geo.str);
          event.target = document.getElementById(`twer-popup-id-${nextData.id}`);


          TWER.openPopup(event, coords, {
            toggle: false
          });
        } else {
          // Close all popups if global tour popup disabled
          TWER.closePopups();
        }
      }



    });

  }
}

export default TWER_TOUR;

